<template>
  <nav v-if="logged_in" class="navbar navbar-default" role="navigation">
    <div class="container-fluid">
      <div class="navbar-header">
        <button type="button" class="navbar-toggle" @click="show_nav = !show_nav">
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <span v-if="store" class="navbar-brand navbar-left" id="nav-store-name">{{ store.name }}</span>
        <span class="navbar-brand navbar-left hidden-xs" style="padding-top: 10px;">
          <!--<img id="nav-store-logo" src=""/>&lt;!&ndash; Store logo goes here (if set) &ndash;&gt;-->
        </span>
      </div>

      <collapse v-model="show_nav" class="navbar-collapse" style="">
        <ol class="navbar-center breadcrumb text-center hidden-xs ribbon both_ribbon">
          <li>
            <router-link
                :to="{name: 'store-list'}"
            >1. Stores</router-link>
          </li>
          <li v-if="show_store_jobs">
            <router-link
                :to="{name: 'store-jobs', params: {store_id: store.id}}"
            >2. Job Selection</router-link>
          </li>
          <li v-if="show_job_logger">
            <router-link
                :to="{name: 'job-logger', params: {job_id: job.id}}"
            >3. Issue Marker</router-link>
          </li>
          <li v-if="show_job_urgency">
            <router-link
                :to="{name: 'job-urgency', params: {job_id: job.id}}"
            >4. Urgency</router-link>
          </li>
          <li v-if="show_job_review">
            <router-link
                :to="{name: 'job-review', params: {job_id: job.id}}"
            >5. Review</router-link>
          </li>
        </ol>
        <ul class="nav navbar-nav navbar-right hidden-xs">
          <dropdown tag="li">
            <a class="dropdown-toggle" data-role="trigger" style="padding-left: 30px; padding-right: 30px">
              <span class="glyphicon glyphicon-cog"></span>
            </a>
            <template slot="dropdown">
              <li><a href="/dashboard/">Go to Dashboard</a></li>
              <li><a @click.prevent="logout" href="">{{ user.email }} Logout</a></li>
            </template>
          </dropdown>
        </ul>
        <ul class="nav navbar-nav visible-xs">
          <li><a href="/dashboard/">Go to Dashboard</a></li>
          <li><a @click.prevent="logout" href="">{{ user.email }} Logout</a></li>
        </ul>
      </collapse>
    </div>
  </nav>
</template>

<style scoped>
  li {
    padding: 0;
  }
</style>

<script>
  import {mapGetters, mapState} from 'vuex'
  import {Dropdown, Collapse} from "uiv"

  import includes from "lodash/includes"

  export default {
    data () {
      return {
        show_nav: false,
      }
    },
    computed: {
      show_store_jobs () {
        return includes([
          "store-jobs",
          "job-logger",
          "job-urgency",
          "job-review",
        ], this.$route.name) && this.store;
      },
      show_job_logger () {
        return includes([
          "job-logger",
          "job-urgency",
          "job-review",
        ], this.$route.name) && this.job;
      },
      show_job_urgency () {
        return includes([
          "job-urgency",
          "job-review",
        ], this.$route.name) && this.job;
      },
      show_job_review () {
        return "job-review" === this.$route.name && this.job;
      },
      ...mapGetters([
        "store",
        "job",
        "logged_in",
      ]),
      ...mapState(["user"])
    },
    methods: {
      async logout () {
        await this.$http.post("/api/logout/");
        this.$store.commit("set_user", null);
        this.$router.push({name: "login"});
      },

    },
    components: {
      Dropdown,
      Collapse
    }
  }
</script>



// WEBPACK FOOTER //
// assets/vue/logger/LoggerNavbar.vue?6dacec61